import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import { categoryLinks, mainSiteUrl } from "@/pages/home/data/categories";

function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-4">
            {t("categories.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            {t("categories.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categoryLinks.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2 p-3 md:p-4 bg-background-100 rounded-lg hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full aspect-square rounded-md overflow-hidden mb-1">
                <img
                  src={cat.image}
                  alt={t(cat.labelKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-600 font-medium text-center leading-tight whitespace-nowrap">
                {t(cat.labelKey)}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function SEOArticlesSection() {
  const { t } = useTranslation();

  const articles = [
    {
      slug: "/articolo/guida-completa-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20with%20laptop%20displaying%20organized%20spreadsheet%20interface%20warm%20natural%20light%20cream%20desk%20with%20notebook%20and%20plant%20European%20minimalist%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20editorial%20photography%20high%20quality%20professional%20atmosphere&width=600&height=400&seq=seo-card-guida&orientation=landscape",
      titleKey: "seoArticles.articles.guida.title",
      excerptKey: "seoArticles.articles.guida.excerpt",
      categoryKey: "seoArticles.articles.guida.category",
    },
    {
      slug: "/articolo/tutorial-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20keyboard%20with%20spreadsheet%20tutorial%20on%20screen%20warm%20natural%20light%20cream%20desk%20with%20coffee%20cup%20and%20handwritten%20notes%20European%20minimalist%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20learning%20atmosphere%20editorial%20photography%20high%20quality&width=600&height=400&seq=seo-card-tutorial&orientation=landscape",
      titleKey: "seoArticles.articles.tutorial.title",
      excerptKey: "seoArticles.articles.tutorial.excerpt",
      categoryKey: "seoArticles.articles.tutorial.category",
    },
    {
      slug: "/articolo/sicurezza-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20clean%20desk%20showing%20a%20digital%20padlock%20security%20icon%20on%20screen%20warm%20natural%20light%20cream%20surface%20with%20notebook%20European%20minimalist%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20professional%20editorial%20photography%20high%20quality%20cybersecurity%20concept&width=600&height=400&seq=seo-card-sicurezza&orientation=landscape",
      titleKey: "seoArticles.articles.sicurezza.title",
      excerptKey: "seoArticles.articles.sicurezza.excerpt",
      categoryKey: "seoArticles.articles.sicurezza.category",
    },
    {
      slug: "/articolo/template-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Desktop%20screen%20displaying%20colorful%20organized%20spreadsheet%20templates%20and%20charts%20warm%20natural%20light%20clean%20cream%20desk%20with%20notebook%20and%20coffee%20European%20minimalist%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20professional%20workspace%20editorial%20photography%20high%20quality&width=600&height=400&seq=seo-card-template&orientation=landscape",
      titleKey: "seoArticles.articles.template.title",
      excerptKey: "seoArticles.articles.template.excerpt",
      categoryKey: "seoArticles.articles.template.category",
    },
    {
      slug: "/articolo/alternative-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20on%20a%20cream%20desk%20each%20showing%20different%20software%20interfaces%20comparison%20concept%20warm%20natural%20light%20clean%20minimalist%20workspace%20European%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20editorial%20photography%20high%20quality&width=600&height=400&seq=seo-card-alternative&orientation=landscape",
      titleKey: "seoArticles.articles.alternative.title",
      excerptKey: "seoArticles.articles.alternative.excerpt",
      categoryKey: "seoArticles.articles.alternative.category",
    },
    {
      slug: "/articolo/come-funziona-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20clean%20desk%20showing%20interactive%20data%20visualization%20and%20charts%20on%20screen%20warm%20natural%20light%20cream%20surface%20with%20coffee%20cup%20European%20minimalist%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20professional%20editorial%20photography%20high%20quality%20tech%20workspace&width=600&height=400&seq=seo-card-comefunziona&orientation=landscape",
      titleKey: "seoArticles.articles.comeFunziona.title",
      excerptKey: "seoArticles.articles.comeFunziona.excerpt",
      categoryKey: "seoArticles.articles.comeFunziona.category",
    },
    {
      slug: "/articolo/recensione-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Clean%20desk%20with%20laptop%20showing%20star%20ratings%20and%20review%20interface%20on%20screen%20warm%20natural%20light%20notebook%20with%20handwritten%20feedback%20notes%20and%20coffee%20cup%20European%20minimalist%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20editorial%20photography%20high%20quality&width=600&height=400&seq=seo-card-recensione&orientation=landscape",
      titleKey: "seoArticles.articles.recensione.title",
      excerptKey: "seoArticles.articles.recensione.excerpt",
      categoryKey: "seoArticles.articles.recensione.category",
    },
    {
      slug: "/articolo/confronto-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Three%20devices%20on%20a%20cream%20desk%20each%20showing%20different%20spreadsheet%20applications%20side%20by%20side%20comparison%20warm%20natural%20light%20clean%20minimalist%20workspace%20European%20aesthetic%20soft%20shadows%20neutral%20beige%20tones%20professional%20editorial%20photography%20high%20quality&width=600&height=400&seq=seo-card-confronto&orientation=landscape",
      titleKey: "seoArticles.articles.confronto.title",
      excerptKey: "seoArticles.articles.confronto.excerpt",
      categoryKey: "seoArticles.articles.confronto.category",
    },
    {
      slug: "/articolo/opinioni-itaobuy-spreadsheet",
      image: "https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20collaborating%20around%20a%20laptop%20in%20a%20bright%20modern%20workspace%20warm%20natural%20light%20cream%20and%20beige%20interior%20plants%20on%20desk%20European%20minimalist%20aesthetic%20soft%20shadows%20positive%20atmosphere%20editorial%20photography%20high%20quality&width=600&height=400&seq=seo-card-opinioni&orientation=landscape",
      titleKey: "seoArticles.articles.opinioni.title",
      excerptKey: "seoArticles.articles.opinioni.excerpt",
      categoryKey: "seoArticles.articles.opinioni.category",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-4">
            {t("seoArticles.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            {t("seoArticles.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 rounded-lg overflow-hidden hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={t(article.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
                  {t(article.categoryKey)}
                </span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 font-semibold mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {t(article.titleKey)}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {t(article.excerptKey)}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-500 font-medium group-hover:gap-2 transition-all">
                  {t("seoArticles.readMore")}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function WhatIs() {
  const { t } = useTranslation();

  return (
    <section id="what-is" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-6">
              {t("whatIs.title")}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {t("whatIs.description")}
            </p>
            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: "ri-database-2-line", title: t("whatIs.features.data"), desc: t("whatIs.features.data_desc") },
                { icon: "ri-file-text-line", title: t("whatIs.features.templates"), desc: t("whatIs.features.templates_desc") },
                { icon: "ri-team-line", title: t("whatIs.features.collab"), desc: t("whatIs.features.collab_desc") },
                { icon: "ri-flashlight-line", title: t("whatIs.features.automation"), desc: t("whatIs.features.automation_desc") },
              ].map((item, i) => (
                <div key={i} className="p-4 bg-background-100 rounded-lg">
                  <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-50 mb-2">
                    <i className={`${item.icon} text-primary-500 text-sm`}></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-1">{item.title}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20premium%20fashion%20accessories%20including%20a%20designer%20watch%20minimalist%20leather%20wallet%20and%20silk%20scarf%20arranged%20on%20a%20warm%20cream%20marble%20surface%20soft%20natural%20daylight%20refined%20European%20editorial%20aesthetic%20sophisticated%20neutral%20warm%20tones%20luxurious%20simple%20composition%20high%20quality&width=800&height=600&seq=whatis-section-v2&orientation=landscape"
                alt="Itaobuy Spreadsheet prodotti"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function WhyChoose() {
  const { t } = useTranslation();

  const cards = [
    { icon: "ri-user-smile-line", title: t("whyChoose.cards.easy.title"), desc: t("whyChoose.cards.easy.desc") },
    { icon: "ri-bar-chart-box-line", title: t("whyChoose.cards.professional.title"), desc: t("whyChoose.cards.professional.desc") },
    { icon: "ri-rocket-line", title: t("whyChoose.cards.productivity.title"), desc: t("whyChoose.cards.productivity.desc") },
    { icon: "ri-tools-line", title: t("whyChoose.cards.tools.title"), desc: t("whyChoose.cards.tools.desc") },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-4">
            {t("whyChoose.title")}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div key={i} className="group p-6 md:p-8 bg-background-50 rounded-lg hover:bg-primary-50/50 transition-colors duration-300">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${card.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-800 mb-3">{card.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Comparison() {
  const { t } = useTranslation();

  const rows = [
    { label: t("comparison.rows.ease"), itaobuy: t("comparison.rows.ease_itaobuy"), excel: t("comparison.rows.ease_excel"), gsheets: t("comparison.rows.ease_gsheets") },
    { label: t("comparison.rows.collab"), itaobuy: t("comparison.rows.collab_itaobuy"), excel: t("comparison.rows.collab_excel"), gsheets: t("comparison.rows.collab_gsheets") },
    { label: t("comparison.rows.cloud"), itaobuy: t("comparison.rows.cloud_itaobuy"), excel: t("comparison.rows.cloud_excel"), gsheets: t("comparison.rows.cloud_gsheets") },
    { label: t("comparison.rows.automation"), itaobuy: t("comparison.rows.automation_itaobuy"), excel: t("comparison.rows.automation_excel"), gsheets: t("comparison.rows.automation_gsheets") },
    { label: t("comparison.rows.online"), itaobuy: t("comparison.rows.online_itaobuy"), excel: t("comparison.rows.online_excel"), gsheets: t("comparison.rows.online_gsheets") },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-4">
            {t("comparison.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t("comparison.subtitle")}
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200/70">
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">{t("comparison.feature")}</th>
                <th className="text-center px-5 py-4 font-semibold text-primary-600 whitespace-nowrap">{t("comparison.itaobuy")}</th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-700 whitespace-nowrap">{t("comparison.excel")}</th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-700 whitespace-nowrap">{t("comparison.googleSheets")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}>
                  <td className="px-5 py-3.5 text-foreground-700 font-medium whitespace-nowrap">{row.label}</td>
                  <td className="px-5 py-3.5 text-center text-primary-600 font-semibold whitespace-nowrap">{row.itaobuy}</td>
                  <td className="px-5 py-3.5 text-center text-foreground-600 whitespace-nowrap">{row.excel}</td>
                  <td className="px-5 py-3.5 text-center text-foreground-600 whitespace-nowrap">{row.gsheets}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

function Security() {
  const { t } = useTranslation();

  const points = [
    { icon: "ri-shield-check-line", text: t("security.points.encryption") },
    { icon: "ri-lock-line", text: t("security.points.privacy") },
    { icon: "ri-user-settings-line", text: t("security.points.access") },
    { icon: "ri-refresh-line", text: t("security.points.backup") },
    { icon: "ri-verified-badge-line", text: t("security.points.compliance") },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-5">
              {t("security.title")}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {t("security.description")}
            </p>
            <div className="space-y-3">
              {points.map((point, i) => (
                <div key={i} className="flex items-start gap-3 p-3 bg-background-50 rounded-lg">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-50 mt-0.5">
                    <i className={`${point.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <span className="text-sm text-foreground-700 leading-relaxed pt-1">{point.text}</span>
                </div>
              ))}
            </div>
            <Link
              to="/articolo/sicurezza-itaobuy-spreadsheet"
              className="inline-flex items-center gap-2 mt-6 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
            >
              {t("security.cta")}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20security%20concept%20photography%20featuring%20a%20modern%20digital%20padlock%20icon%20on%20a%20laptop%20screen%20placed%20on%20a%20warm%20cream%20desk%20with%20soft%20natural%20light%20flowing%20through%20sheer%20curtains%20clean%20professional%20atmosphere%20European%20editorial%20aesthetic%20neutral%20warm%20tones%20calm%20and%20secure%20ambiance%20high%20quality&width=800&height=600&seq=security-section-v2&orientation=landscape"
                alt="Sicurezza Itaobuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
    { q: t("faq.q5"), a: t("faq.a5") },
    { q: t("faq.q6"), a: t("faq.a6") },
    { q: t("faq.q7"), a: t("faq.a7") },
    { q: t("faq.q8"), a: t("faq.a8") },
    { q: t("faq.q9"), a: t("faq.a9") },
    { q: t("faq.q10"), a: t("faq.a10") },
  ];

  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-semibold mb-4">
            {t("faq.title")}
          </h2>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200 overflow-hidden"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4" itemProp="name">
                  {item.q}
                </span>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-200 ${openIndex === i ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              {openIndex === i && (
                <div
                  className="px-5 pb-4"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 px-4 md:px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20ambient%20boutique%20fashion%20retail%20interior%20with%20neatly%20displayed%20premium%20clothing%20and%20accessories%20on%20minimal%20wooden%20shelving%20soft%20golden%20hour%20light%20streaming%20through%20large%20windows%20cozy%20sophisticated%20atmosphere%20cream%20beige%20and%20warm%20earth%20tones%20European%20minimalist%20aesthetic%20editorial%20photography%20high%20quality&width=1800&height=800&seq=cta-bg-fashion-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet CTA"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 font-semibold mb-5">
          {t("ctaSection.title")}
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 leading-relaxed">
          {t("ctaSection.subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            {t("ctaSection.button")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-base rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            {t("hero.cta_secondary")}
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900 text-background-50/80 py-14 md:py-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-xl text-background-50 font-semibold mb-4">
              Itaobuy <span className="text-primary-400">Spreadsheet</span>
            </h3>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              {t("footer.quickLinks")}
            </h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Home
              </Link>
              <a href="#what-is" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t("nav.guide")}
              </a>
              <a href="#faq" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t("nav.faq")}
              </a>
              <Link to="/articolo/guida-completa-itaobuy-spreadsheet" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t("nav.blog")}
              </Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t("nav.shoppingGuide")}
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              {t("footer.categories")}
            </h4>
            <div className="space-y-2.5">
              {categoryLinks.slice(0, 7).map((cat) => (
                <a
                  key={cat.key}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {t(cat.labelKey)}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              {t("footer.resources")}
            </h4>
            <div className="space-y-2.5">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t("hero.cta_primary")}
              </a>
              <Link to="/articolo/tutorial-itaobuy-spreadsheet" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Tutorial
              </Link>
              <Link to="/articolo/sicurezza-itaobuy-spreadsheet" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Sicurezza
              </Link>
              <Link to="/articolo/recensione-itaobuy-spreadsheet" className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Recensione
              </Link>
              <span className="block text-sm text-background-50/60 whitespace-nowrap">{t("footer.contact")}</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-6 flex-wrap">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta_primary")}
            </a>
            <Link
              to="/articolo/guida-completa-itaobuy-spreadsheet"
              className="text-xs text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("nav.blog")}
            </Link>
            <Link
              to="/articolo/alternative-itaobuy-spreadsheet"
              className="text-xs text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Alternative
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <SEOArticlesSection />
      <WhatIs />
      <WhyChoose />
      <Comparison />
      <Security />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}